import React from 'react';
import './StaticNotFound.css'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';



function StaticNotFound() {

    return (
        <div style={{ fontFamily: 'Noto Sans', display: 'flex', justifyContent: 'center' }}>
            <div style={{ marginTop: '40vh' }}>
                <div style={{ fontSize: '64px' }}>
                    404 Static Not Found.
                </div>
                <div style={{ fontSize: '16px', textAlign: 'center' }}>
                    Make sure the link you entered was correct.
                </div>
                <div style={{ fontSize: '16px', textAlign: 'center', marginTop: '10px' }}>
                    <a className='staticNotFound' href='/gearing'>Or create a new static <KeyboardReturnIcon sx={{ width: '20px', marginBottom: '-7px' }} /></a>
                </div>
            </div>
        </div>
    );
}

export default StaticNotFound;